import {
    getProfileLoading,
    getProfileReject,
    getProfileRequest,
    getProfileSuccess
} from "../../actions/profile/getAll";

export const getProfile = (formData) => async (dispatch, getState) => {
    dispatch(getProfileLoading());
    try {
        const { data } = await getProfileRequest(formData, getState);
        dispatch(getProfileSuccess(data))
    } catch (error) {
        dispatch(getProfileReject(error))
    }
    return Promise.resolve();
};